import Modal from "../../components/general/Modal";
import Image from "../../components/general/Image";
import { SuccessModalImage } from "../../constants/ImagePaths";

const SuccessModal = ({ show, onClose }) => {
    return (
        <div>
            <Modal show={show} containerClasses="!bg-[#292929] rounded">
                <div className="flex items-center justify-end px-[20px] py-[10px]">
                    <svg onClick={onClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-white cursor-pointer">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>
                <div className="flex items-center justify-center flex-col text-white text-[24px]">
                    <Image className='w-[200px]' src="/images/logo.png" alt="success" useImageKit={false} />
                    <p className="my-[20px]"> <strong>Awesome!</strong> Within the <strong>next 24 hours</strong>, our team <br className="hidden md:block" /> will connect with you to seamlessly guide you <br className="hidden md:block" /> through the next steps </p>
                </div>

                <Image className='w-full' src={SuccessModalImage} alt="success" />
            </Modal>
        </div>
    )
}

export default SuccessModal;